<div class="list-wrap">

  <div class="list-tit-box"
       *ngIf="dispTxt">{{ dispTxt }}</div>

  <ul #scrollContainer
      class="scroll-effect over-y"
      (scroll)="onScroll($event)">
    <li *ngFor="let saseung3 of ll?.getList()"
        [class.small-text]="saseung3.order1 === '2'">
      <app-saseung3-item class="item-box"
                         [saseung3]="saseung3"
                         [showHangul]="showHangul"
                         (bookmarkChange)="onBookmarkChange($event)">
      </app-saseung3-item>
    </li>

    <li>
      <div class="item-box" *ngIf="ll && !ll.IsComplete()">
        <div class="reload-icon">
          <img #reload
               src="assets/img/loading_icon.gif">
        </div>
      </div>
    </li>

    <!-- 항목 없음 표시 -->
    <li class="no-result" *ngIf="isNoResult()">
      <div class="no-result-img"></div>
      <div class="no-result-txt">문자가 없습니다.</div>
    </li>
  </ul>

</div>
